import React, { useState, useEffect } from "react";
import {
  ConfigProvider,
  Input,
  Table,
  Tag,
  theme,
  Select,
  Tooltip,
  Switch,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { colors } from "./../../devdata/constants/themes";
import PiScoreTag from "../piScoreTag"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faStar,
  faSearch,
  faFilter,
  faArrowsRotate,
  faAlignRight,
  faCircleInfo,
  faInfo,
  faArrowRight,
  faArrowDownAZ,
  faArrowUpAZ,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { Subhai } from "..";

import { Statescontex, useUserContext } from "../../context";
import { Demohai, Livehai } from "..";
import { stocks } from "../../devdata/maps/chartred";

import classNames from "classnames";
import { whaticonstocks } from "../../devdata/maps/whaticon";

// import classNames from "classnames";

const SectorTableCard = ({ title, description, selectedSector2 }) => {
  const { setdaystocks, daystocks, userdetails, isDhanLogged, dhanToken } = useUserContext();
  const [loading, setLoading] = useState(false);
  const { setErrorMessage, setErrorshow } = Statescontex();

  const { live } = Statescontex();

  const [priceSortOrder, setPriceSortOrder] = useState<
    "descend" | "ascend" | "none"
  >("none");
  const [changeSortOrder, setChangeSortOrder] = useState<
    "descend" | "ascend" | "none"
  >("none");
  const [pisort, setPisort] = useState<"ascend" | "descend" | "none">(
    "descend"
  );
  const [stocknamesort, setstocknamesort] = useState<
    "ascend" | "descend" | "none"
  >("none");
  const [sortkey, setSortkey] = useState("pil");
  const [favorites, setFavorites] = useState(new Set());
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [data, setdata] = useState([]); // Renamed from stocks to data to match Sectable
  const [sectors, setSectors] = useState([]);
  const [selectedSector, setSelectedSector] = useState(selectedSector2); // Default selected sector
  const [showGoodToEnter, setShowGoodToEnter] = useState(false); // State for toggle
  const [filteredData, setFilteredData] = useState([]);

  const handleCloseSearch = () => {
    if (!searchValue) {
      setSearchVisible(false);
      handleSearch("");
    }
  };

  // --- Filtering and Sorting Logic ---
  const applyFilters = (
    sourceData,
    sector,
    showGood,
    search,
    sortOrder,
    sortkey
  ) => {
    // console.log(sortOrder);

    let intermediateData = [...sourceData];

    if (showGood) {
      intermediateData = intermediateData.filter((stock) => stock.pil >= 8);
    }
    if (sector !== "All Sectors") {
      intermediateData = intermediateData.filter(
        (stock) => stock.sector === sector
      );
    }
    if (search) {
      intermediateData = intermediateData.filter((stock) =>
        stock.name.toLowerCase().startsWith(search.toLowerCase())
      );
    }
    if (sortOrder && sortkey !== "") {
      // Apply final sort order
      if (sortkey === "close") {
        sortData(intermediateData, sortkey, sortOrder);
        setPisort("none");
        setChangeSortOrder("none");
        setstocknamesort("none");
      } else if (sortkey === "pil") {
        sortData(intermediateData, sortkey, sortOrder);
        setPriceSortOrder("none");
        setChangeSortOrder("none");
        setstocknamesort("none");
      } else if (sortkey === "name") {
        sortData(intermediateData, sortkey, sortOrder);
        setPriceSortOrder("none");
        setChangeSortOrder("none");
        setPisort("none");
      } else if (sortkey === "per_chg") {
        sortData(intermediateData, sortkey, sortOrder);
        setPriceSortOrder("none");
        setPisort("none");
        setstocknamesort("none");
      } else {
        sortData(intermediateData, sortkey, sortOrder);
        setPriceSortOrder("none");
        setChangeSortOrder("none");
        setPisort("none");
      }
    }
  };

  const sortData = (dataToSort, key, direction) => {
    if (direction === "none") {
      sortData(dataToSort, "name", "ascend");
    } else if (key === "name") {
      const sorted = [...dataToSort].sort((a, b) => {
        const aValue = a[key];
        const bValue = b[key];
        return direction === "ascend"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      });
      setFilteredData(sorted);
    } else {
      const sorted = [...dataToSort].sort((a, b) => {
        const aValue = a[key];
        const bValue = b[key];
        // Handle potential non-numeric values during sort
        const numA = typeof aValue === "number" ? aValue : -Infinity;
        const numB = typeof bValue === "number" ? bValue : -Infinity;
        return direction === "ascend" ? numA - numB : numB - numA;
      });
      setFilteredData(sorted);
    }
  };

  const fetchitup = () => {
    try {
      const d = sessionStorage.getItem("all");
      if (d) {
        const parseddata = JSON.parse(d);
        setdata(parseddata);

        // Set unique sectors
        const uniqueSectors = Array.from(
          new Set(parseddata.map((stock) => stock.sector))
        );
        setSectors(uniqueSectors);

        // Apply initial filters
        applyFilters(
          parseddata,
          selectedSector,
          showGoodToEnter,
          searchValue,
          sortkey === "close"
            ? priceSortOrder
            : sortkey === "per_chg"
              ? changeSortOrder
              : sortkey === "name"
                ? stocknamesort
                : pisort,
          sortkey
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage("h_Failed to fetch data");
      setErrorshow(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchitup();
    const interval = setInterval(() => {
      fetchitup();
    }, 1000);
    return () => clearInterval(interval);
  }, [
    selectedSector,
    showGoodToEnter,
    searchValue,
    priceSortOrder,
    sortkey,
    stocknamesort,
    changeSortOrder,
    pisort,
  ]);

  // useEffect(() => {
  //   handleSectorChange(selectedSector);
  //   handleSearch({ target: { value: searchValue } });
  // }, [data]);
  useEffect(() => {
    handleSectorChange(selectedSector2);
  }, [selectedSector2]);
  const toggleFavorite = (key, event) => {
    event.stopPropagation();

    setFavorites((prev) => {
      const updated = new Set(prev);
      if (updated.has(key)) {
        updated.delete(key);
      } else {
        updated.add(key);
      }
      return updated;
    });
    setdaystocks((prev) => {
      if (prev.includes(key)) {
        return prev.filter((stock) => stock !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  // Update handlers to use applyFilters
  const handleSearch = (value) => {
    setSearchValue(value);
    applyFilters(
      data,
      selectedSector,
      showGoodToEnter,
      value,
      priceSortOrder,
      sortkey
    );
  };

  const handleSectorChange = (value) => {
    setSelectedSector(value);
    applyFilters(
      data,
      value,
      showGoodToEnter,
      searchValue,
      priceSortOrder,
      sortkey
    );
  };

  const handleGoodToEnterToggle = (checked) => {
    setShowGoodToEnter(checked);
    applyFilters(
      data,
      selectedSector,
      checked,
      searchValue,
      priceSortOrder,
      sortkey
    );
  };

  // Update sort handlers
  const handlePriceSortChange = () => {
    const newOrder =
      priceSortOrder === "none"
        ? "ascend"
        : priceSortOrder === "ascend"
          ? "descend"
          : "ascend";
    setPriceSortOrder(newOrder);
    setSortkey("close");
    applyFilters(
      data,
      selectedSector,
      showGoodToEnter,
      searchValue,
      newOrder,
      "close"
    );
  };

  const handleChangeSortChange = () => {
    const newOrder =
      changeSortOrder === "none"
        ? "ascend"
        : changeSortOrder === "ascend"
          ? "descend"
          : "ascend";
    setChangeSortOrder(newOrder);
    setSortkey("per_chg");
    applyFilters(
      data,
      selectedSector,
      showGoodToEnter,
      searchValue,
      newOrder,
      "per_chg"
    );
  };
  const handlePisortChange = () => {
    // console.log(pisort);

    const newOrder =
      pisort === "none" ? "ascend" : pisort === "ascend" ? "descend" : "ascend";
    setPisort(newOrder);
    setSortkey("pil");
    applyFilters(
      data,
      selectedSector,
      showGoodToEnter,
      searchValue,
      newOrder,
      "pil"
    );
  };

  const handlestocknamesort = () => {
    // console.log(stocknamesort);

    const newOrder =
      stocknamesort === "none"
        ? "ascend"
        : stocknamesort === "ascend"
          ? "descend"
          : "ascend";
    setstocknamesort(newOrder);
    setSortkey("name");
    applyFilters(
      data,
      selectedSector,
      showGoodToEnter,
      searchValue,
      newOrder,
      "name"
    );
  };
  const columns = [
    {
      title: "",
      width: "2%",

      dataIndex: "nsecode",
      key: "favorite",
      render: (key) => (
        <div
          className="p-2 cursor-pointer flex items-center justify-center"
          onClick={(e) => toggleFavorite(key, e)}
        >
          <FontAwesomeIcon
            icon={faStar}
            className={`${daystocks.includes(key)
              ? "text-yellow-500"
              : "text-darkMode-layer3"
              }`}
          />
        </div>
      ),
    },
    {
      title: (
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            handlestocknamesort();
          }}
        >
          <FontAwesomeIcon
            icon={
              stocknamesort === "ascend"
                ? faArrowUpAZ
                : stocknamesort === "descend"
                  ? faArrowDownAZ
                  : faMinus
            }
            className="mr-2"
          />
          <span>Stock</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text, record) => {

        return (
          <div className="flex items-center gap-2">
            {whaticonstocks[
              stocks.find((stock) => stock.nsecode === record.nsecode)?.name
            ] ? (
              <img
                src={whaticonstocks[text]}
                alt="stock icon"
                className="w-8 h-8 rounded-full object-cover"
              />
            ) : (
              <div className="w-8 h-8 bg-darkMode-layer3 rounded-full flex items-center justify-center">
                <span className="text-white text-xl">?</span>
              </div>
            )}
            <span
              className="cursor-pointer"
              onClick={() => {
                const found = stocks.find(
                  (stock) => stock.nsecode === record.nsecode
                );
                const foundUrl = isDhanLogged ? found?.dhanUrl?.replace("123GOFREE", dhanToken) : found?.url || found?.url
                if (foundUrl) {
                  window.open(foundUrl, "_blank");
                } else {
                  console.error("URL not found");
                }
              }}
            >
              {text}
            </span>
          </div>
        )
      }
    },
    {
      title: (
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            handlePriceSortChange();
          }}
        >
          <FontAwesomeIcon
            icon={
              priceSortOrder === "ascend"
                ? faArrowUp
                : priceSortOrder === "descend"
                  ? faArrowDown
                  : faMinus
            }
            className="mr-2 cursor-pointer"
          />
          <span>Price</span>
        </div>
      ),
      dataIndex: "close",
      key: "close",

      render: (text) => (
        <div>
          {text.toFixed(2)}
          {/* //     <span style={{ fontSize: "0.8rem" }}> INR</span> */}
        </div>
      ),
    },
    {
      title: (
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            handleChangeSortChange();
          }}
        >
          <FontAwesomeIcon
            icon={
              changeSortOrder === "ascend"
                ? faArrowUp
                : changeSortOrder === "descend"
                  ? faArrowDown
                  : faMinus
            }
            className="mr-2"
          />
          <span>% Change</span>
        </div>
      ),
      dataIndex: "per_chg",
      key: "per_chg",
      render: (text) => (
        <Tag
          className={`rounded-full bg-darkMode-layer3 text-xs font-semibold ${text > 0 ? "text-darkMode-green" : "text-darkMode-red/90"
            }`}
        >
          {text}%
        </Tag>
      ),
    },
    {
      title: (
        <div
          className="flex cursor-pointer items-center justify-center"
          onClick={() => {
            handlePisortChange();
          }}
        >
          <FontAwesomeIcon
            icon={
              pisort === "ascend"
                ? faArrowUp
                : pisort === "descend"
                  ? faArrowDown
                  : faMinus
            }
            className="mr-2"
          />
          <span>Pi Score</span>
        </div>
      ),
      dataIndex: "pil",
      key: "pil",
      align: "center",
      render: (text) => <PiScoreTag value={text} />,
    },
    {
      title: "Sector",
      dataIndex: "sector",
      key: "sector",
      align: "center",
    },
    {
      title: "Suggestion",
      dataIndex: "pil",
      key: "good",
      align: "center",
      render: (piScore) => {
        let text = "Ignore";
        let bgColor = "bg-red-500/80";
        let textColor = "text-white";
        let icon = null;

        if (typeof piScore === "number") {
          if (piScore >= 14) {
            text = "Good to Enter";
            bgColor = "bg-darkMode-green/20";
            textColor = "text-darkMode-green";
          } else if (piScore >= 10) {
            text = "Watchlist";
            bgColor = "bg-yellow-500/30";
            textColor = "text-yellow-400";
          }
        }

        // Use min-w to ensure tag doesn't collapse too much
        return (
          <div className="flex items-center justify-center w-full px-1">
            <div
              className={`flex items-center justify-center rounded-full text-xs font-semibold border-0 px-2 py-0.5 text-center whitespace-nowrap min-w-[70px] ${bgColor} ${textColor}`}
            >
              <span>{text}</span>
            </div>
          </div>
        );
      },
    },
    // {
    //   title: "Automate Via AlgoTest",
    //   dataIndex: "sector",
    //   key: "sector",
    //   align: "center",
    //   width: "2%",
    //   render: (text) => {
    //     return (
    //       <div className="flex flex-row items-center justify-center gap-0 hover:cursor-pointer hover:text-darkMode-green">
    //         <FontAwesomeIcon icon={faArrowRight} />
    //       </div>
    //     );
    //   },
    // },
  ];

  return (
    <div className="p-4 rounded-xl bg-darkMode-layer1 shadow-lg w-full">
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2 items-center">
          <div>
            <h2 className="text-xl font-semibold text-darkMode-text">
              Stock Analysis by Sectors
            </h2>
            <p className="text-sm text-darkMode-subText">
              Sector wise details of Stocks.
            </p>
          </div>
          {/* <Livehai /> */}
        </div>
        <div>
          <Demohai what="video url for stock analysis by sectors" />
        </div>
      </div>

      {/* --- Responsive Filters & Search --- */}
      <div className="flex flex-wrap justify-between items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        {/* Good to Enter Toggle */}

        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-3 text-darkMode-text flex-shrink-0">
            <span className="text-sm sm:text-base">Show only</span>
            <div className="rounded-full bg-darkMode-layer3 text-sm sm:text-base font-semibold text-darkMode-green px-4 py-1 whitespace-nowrap">
              <span>Good to Enter</span>
            </div>
            <Switch
              className="transition-all duration-200 scale-110"
              checked={showGoodToEnter}
              onChange={handleGoodToEnterToggle}
              style={{
                backgroundColor: showGoodToEnter
                  ? colors.darkMode.greenDarker
                  : "",
              }}
            />
          </div>
        </div>
        {/* --- Sector and Search Group --- */}
        {/* Allows wrap, pushes right on larger screens */}
        <div className="flex flex-wrap sm:flex-nowrap items-center gap-3 sm:gap-4 w-full sm:w-auto justify-end">
          {/* Sector Selection */}
          {/* Use max-width but allow shrink/grow */}
          <div className="text-darkMode-text w-auto max-w-[180px] sm:max-w-[200px] flex-grow sm:flex-grow-0">
            <Select
              value={selectedSector}
              style={{
                width: "100%",
                minWidth: "100px",
                textAlign: "center",
                height: "40px",
              }}
              onChange={handleSectorChange}
              options={[
                { label: "All Sectors", value: "All Sectors" },
                ...sectors.map((sector) => ({
                  label: sector,
                  value: sector,
                })),
              ]}
              placeholder="Select Sector"
              aria-label="Filter by Sector"
            />
          </div>

          {/* Search Input/Button */}
          {/* Use max-width but allow shrink/grow */}
          <div className="text-darkMode-text w-auto max-w-[180px] sm:max-w-[200px] flex-grow sm:flex-grow-0">
            {searchVisible ? (
              <Input
                className="h-[40px] text-xs sm:text-sm px-3 py-2 rounded-lg bg-darkMode-layer2 shadow-sm transition-all duration-300 ease-in-out border-none hover:ring-1 hover:ring-darkMode-green focus:ring-1 focus:ring-darkMode-green w-full text-white"
                placeholder="Search Stock..."
                prefix={
                  <SearchOutlined className="text-darkMode-subText mr-1" />
                }
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
                allowClear
                autoFocus
                onBlur={handleCloseSearch}
                onPressEnter={handleCloseSearch}
              />
            ) : (
              <button
                className="flex items-center justify-center h-[40px] text-xs sm:text-sm px-3 py-2 rounded-lg bg-darkMode-layer2 shadow-sm transition-all duration-300 ease-in-out hover:ring-1 hover:ring-darkMode-green text-darkMode-subText hover:text-darkMode-text w-full"
                onClick={() => setSearchVisible(true)}
                aria-label="Open search input"
              >
                <FontAwesomeIcon icon={faSearch} className="mr-1.5" />
                <span>Search</span>
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="relative">
        <Subhai />
        <Table
          dataSource={filteredData}
          columns={columns}
          rowKey="nsecode"
          style={{
            minHeight:
              userdetails?.isverified === false || userdetails?.subexp === true
                ? 300
                : 400,
          }}
          pagination={{
            defaultPageSize: 5,
            total: filteredData.length,
          }}
          scroll={{ x: "max-content" }}
          className="rounded-lg overflow-hidden shadow-sm text-darkMode-text"
          rowClassName="cursor-default"
          size="middle"
        />
      </div>
    </div>
  );
};

export default SectorTableCard;
